import React from 'react';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FaBriefcase, FaGraduationCap } from 'react-icons/fa';
import '../styles/Experience.css';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

function Experience() {
  const { language } = useLanguage();
  const t = translations[language].experience;
  
  const iconStyle = { background: '#6c63ff', color: '#fff' };
  const contentStyle = { background: '#1a1a2e', color: '#e0e0e0', border: '1px solid rgba(255, 255, 255, 0.1)' };
  const contentArrowStyle = { borderRight: '7px solid  #1a1a2e' };

  const entries = [
    {
      key: 'product-engineer',
      kind: 'work',
      date: t.timeline.productEngineer.date,
      title: t.timeline.productEngineer.company,
      subtitle: t.timeline.productEngineer.type,
      details: [t.timeline.productEngineer.summary, t.timeline.productEngineer.products],
    },
    {
      key: 'green-nature',
      kind: 'work',
      date: t.timeline.greenNature.date,
      title: t.timeline.greenNature.company,
      subtitle: t.timeline.greenNature.type,
      details: [t.timeline.greenNature.summary],
    },
    {
      key: 'seven-sense',
      kind: 'work',
      date: t.timeline.sevenSense.date,
      title: t.timeline.sevenSense.company,
      subtitle: t.timeline.sevenSense.type,
      details: [t.timeline.sevenSense.summary],
    },
    {
      key: 'degree',
      kind: 'education',
      date: 'May 2021 - April 2024',
      title: t.timeline.degree.school,
      subtitle: t.timeline.degree.type,
      details: [
        <React.Fragment key='degree-vp'>May 2021 - January 2022<br />{t.timeline.degree.role1}</React.Fragment>,
        <React.Fragment key='degree-president'>January 2022 - January 2023<br />{t.timeline.degree.role2}</React.Fragment>,
        <React.Fragment key='degree-treasurer'>January 2023 - January 2024<br />{t.timeline.degree.role3}</React.Fragment>,
      ],
    },
    {
      key: 'diploma',
      kind: 'education',
      date: 'January 2019 - April 2021',
      title: t.timeline.diploma.school,
      subtitle: t.timeline.diploma.type,
      details: [
        <React.Fragment key='diploma-club'>May 2019 - April 2021<br />{t.timeline.diploma.description1}</React.Fragment>,
        t.timeline.diploma.description2,
      ],
    },
    {
      key: 'secondary',
      kind: 'education',
      date: '2013 - 2017',
      title: t.timeline.secondary.school,
      subtitle: t.timeline.secondary.type,
      details: [t.timeline.secondary.description],
    },
  ];

  return (
    <div className='experience'>
      <h1 className='page-title'>{t.title}</h1>
      <VerticalTimeline lineColor='#6c63ff'>
        {entries.map((entry) => (
          <VerticalTimelineElement
            key={entry.key}
            className={`vertical-timeline-element--${entry.kind}`}
            date={entry.date}
            iconStyle={iconStyle}
            contentStyle={contentStyle}
            contentArrowStyle={contentArrowStyle}
            icon={entry.kind === 'work' ? <FaBriefcase /> : <FaGraduationCap />}
          >
            <h3 className="vertical-timeline-element-title">{entry.title}</h3>
            <h4 className="vertical-timeline-element-subtitle">{entry.subtitle}</h4>
            {entry.details.map((detail, index) => (
              <p key={`${entry.key}-${index}`}>{detail}</p>
            ))}
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </div>
  )
}

export default Experience;
